const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/**
 * Normaliseert vertaalde configuratorteksten die door Shopify als
 * HTML-entiteiten zijn uitgevoerd, bijvoorbeeld &amp; en &lt;p&gt;.
 */
(() => {
  const ROOT_SELECTOR = '.ew10';
  const CONFIG_SELECTOR = 'script[data-config]';
  const TEXT_ATTRIBUTES = ['aria-label', 'title', 'placeholder', 'value'];
  const decoder = document.createElement('textarea');

  function decodeText(value) {
    let result = String(value ?? '');

    for (let pass = 0; pass < 3; pass += 1) {
      decoder.innerHTML = result;
      const decoded = decoder.value;
      if (decoded === result) break;
      result = decoded;
    }

    return result
      .replace(/<br\s*\/?>/gi, ' ')
      .replace(/<\/?p\b[^>]*>/gi, '')
      .replace(/<[^>]+>/g, '');
  }

  function cleanValue(value) {
    if (typeof value === 'string') return decodeText(value);
    if (Array.isArray(value)) return value.map(cleanValue);

    if (value && typeof value === 'object') {
      Object.keys(value).forEach((key) => {
        value[key] = cleanValue(value[key]);
      });
    }

    return value;
  }

  function cleanConfigScripts() {
    document.querySelectorAll(CONFIG_SELECTOR).forEach((script) => {
      if (script.dataset.ewEntitiesCleaned === 'true') return;

      try {
        const config = JSON.parse(script.textContent);
        script.textContent = JSON.stringify(cleanValue(config));
        script.dataset.ewEntitiesCleaned = 'true';
      } catch (error) {
        console.warn('[Edelmanwatches] Vertaalcodes konden niet worden opgeschoond.', error);
      }
    });
  }

  function cleanRoot(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const tagName = node.parentElement?.tagName || '';
        return /^(SCRIPT|STYLE|NOSCRIPT|TEMPLATE)$/i.test(tagName)
          ? NodeFilter.FILTER_REJECT
          : NodeFilter.FILTER_ACCEPT;
      },
    });

    const textNodes = [];
    while (walker.nextNode()) textNodes.push(walker.currentNode);

    textNodes.forEach((node) => {
      const cleaned = decodeText(node.nodeValue);
      if (cleaned !== node.nodeValue) node.nodeValue = cleaned;
    });

    root.querySelectorAll('[aria-label], [title], [placeholder], [value]').forEach((element) => {
      TEXT_ATTRIBUTES.forEach((attribute) => {
        if (!element.hasAttribute(attribute)) return;
        const original = element.getAttribute(attribute);
        const cleaned = decodeText(original);
        if (cleaned !== original) element.setAttribute(attribute, cleaned);
      });
    });
  }

  function runCleanup() {
    cleanConfigScripts();
    document.querySelectorAll(ROOT_SELECTOR).forEach(cleanRoot);
  }

  let cleanupScheduled = false;
  function scheduleCleanup() {
    if (cleanupScheduled) return;
    cleanupScheduled = true;

    window.requestAnimationFrame(() => {
      cleanupScheduled = false;
      runCleanup();
    });
  }

  runCleanup();

  const observer = new MutationObserver(records => {
    if (records.some(record => !record.target.parentElement?.closest('.ew131-scene'))) scheduleCleanup();
  });
  observer.observe(document.documentElement, {
    subtree: true,
    childList: true,
    characterData: true,
    attributes: true,
    attributeFilter: TEXT_ATTRIBUTES,
  });

  document.addEventListener('DOMContentLoaded', scheduleCleanup, { once: true });
  window.addEventListener('load', scheduleCleanup, { once: true });
})();
